import styled from "@emotion/styled";

export const Container = styled.div`
  display: flex;
  min-height: 38px;
  box-sizing: border-box;
  align-items: center;
  padding: 0 12px;

  cursor: pointer;

  &:hover {
    background-color: var(--component-color-fill-normal);
  }
`;
